/*
 * 文件EN: involveControl.js,
 * 文件CN: 日常工作-摄控名单,

 */

import request from '@/plugins/http'

/**
 * @desc T7-日常工作-摄控名单  第一个table 主页列表
 * @method GET
 * @param {}
 */
export const getListData = params => {
  return request.get('/involveControl/list', params)
}